import { lazy } from 'react';

export const TaxAdministration = lazy(() =>
  import('../taxAdministration.routing').then((module) => ({
    default: module.TaxesAdministration
  }))
);
